
        var result = require("!!../../../../node_modules/css-loader/index.js!./vendors.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./ClientApp/app/components/vendors/vendors.component.css
// module id = 553
// module chunks = 0